import { QueryClient } from "@tanstack/vue-query";

export async function invalidateDashboardQueries(queryClient: QueryClient) {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ["dashboard"] }),
    queryClient.invalidateQueries({ queryKey: ["inventario"] }),
    queryClient.invalidateQueries({ queryKey: ["productos-mas-vendidos"] }),
    queryClient.invalidateQueries({ queryKey: ["top-clientes"] }),
    queryClient.invalidateQueries({ queryKey: ["ventas-categoria"] }),
    queryClient.invalidateQueries({ queryKey: ["ventas-metodo-pago"] }),
    queryClient.invalidateQueries({ queryKey: ["ventas-periodo"] }),
  ]);
}